export const layoutsMisc = {
  confirm: {
    defaultTitle: "Are you sure?",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  navPluginWeb: {
    title: "Create website",
    stepOf: "{step} of 5",
  },
  saMenu: {
    title: "System actions",
    subtitle: "Automations panel",
    sectionComms: "COMMUNICATIONS",
    firstCheckin: "Send on first check-in",
  },
  systemActions: {
    checkin: "Check-in",
  },
  regionMessage: {
    text: "Contact the support team to set up the connection.",
    contactSupport: "Contact support",
  },
  selectionScanner: {
    title: "Choose the type of document to scan",
    idCard: "ID card",
    passport: "Passport",
  },
};
